import { Page } from "./types";

export const pages: Page[] = [
  {
    id: 1,
    title: "Introduction",
    page_id: "422609077",
    children: [
      {
        id: 10,
        title: "What is TDSP?",
        page_id: "422641971",
      },
      {
        id: 11,
        title: "TDSP Architecture",
        page_id: "422674778",
      },
      {
        id: 12,
        title: "Who are the users of our platform?",
        page_id: "423100470",
      },
      {
        id: 121,
        title: "How to access AWS Environment?",
        page_id: "370303306",
      },
      {
        id: 122,
        title: "What can I do with the AWS Console?",
        page_id: "370844882",
      },
      {
        id: 123,
        title: "User Role vs Service Role vs Jenkins Role?",
        page_id: "370844896",
      },
    ],
  },

  {
    id: 3,
    title: "Getting Started",
    page_id: "422609098",
    children: [
      {
        id: 31,
        title: "What is a POD?",
        page_id: "363699259",
      },
      {
        id: 32,
        title: "Roles - How to Access TDSP",
        page_id: "373722811",
      }
    ],
  },
  {
    id: 30,
    title: "Onboarding into TDSP (1TS)",
    page_id: "423100487",
    children: [
      {
        id: 301,
        title: "Onboarding a New Team",
        page_id: "423067797",
      },
      {
        id: 302,
        title: "Onboarding Process Flow and Checklist",
        page_id: "359861389",
      },
      // {
      //   id: 303,
      //   title: "Onboarding a new user into an existing team",
      //   page_id: "423067835",  // NotFound (404)
      // },
      {
        id: 304,
        title: "Onboarding New User to Existing POD/Team",
        page_id: "359860118",
      },
      {
        id: 305,
        title: "Data Access Request (DAR)",
        page_id: "360356761",
      },
    ],
  },
  {
    id: 2,
    title: "Data Ingestion",
    page_id: "422674669",
    children: [
      {
        id: 21,
        title: "Data Sources and Formats",
        page_id: "423002296",
      },
    ],
  },
  {
    id: 4,
    title: "Data Exploration and Analysis",
    page_id: "422707454",
    children: [
      {
        id: 41,
        title: "Exploratory Data Analysis (EDA)",
        page_id: "370302593",
      },
      {
        id: 42,
        title: "Advanced Analytics with Databricks",
        page_id: "423067970",
      },
    ],
  },
  {
    id: 5,
    title: "Data Processing and Transformation",
    page_id: "422609182",
    children: [
      {
        id: 51,
        title: "Data Pre-Processing/Engineering",
        page_id: "370268570",
      },
      {
        id: 52,
        title: "Feature Engineering",
        page_id: "370334428",
      },
      {
        id: 53,
        title: "Data Engineering",
        page_id: "370270208",
      },
    ],
  },
  {
    id: 6,
    title: "Model Development and Machine Learning",
    page_id: "422674698",
    children: [
      {
        id: 60,
        title: "About",
        page_id: "422674698",
      },
      {
        id: 61,
        title: "Model Development/Training",
        page_id: "370302702",
      },
      {
        id: 62,
        title: "Model Experiments",
        page_id: "370334982",
      },
      {
        id: 63,
        title: "Model Registry on TDSP",
        page_id: "370369177",
      },
    ],
  },
  {
    id: 7,
    title: "MLOPS",
    page_id: "290719090",
    children: [
      {
        id: 70,
        title: "About",
        page_id: "290719090",
      },
      {
        id: 71,
        title: "Structured Data Science MLOps",
        page_id: "290719309",
      },
      {
        id: 72,
        title: "Pre-Requisites",
        page_id: "290719096",
      },
      {
        id: 73,
        title: "Project structure",
        page_id: "290718646",
      },
      {
        id: 74,
        title: "Supported patterns",
        page_id: "290718927",
      },
      {
        id: 75,
        title: "Generate and commit",
        page_id: "290718616",
      },
      {
        id: 76,
        title: "Jenkins setup",
        page_id: "290718492",
      },
      {
        id: 77,
        title: "Deployment Patterns",
        page_id: "290719549",
      },
      {
        id: 78,
        title: "TDSP MLOps Terraform Module",
        page_id: "290719338",
      },
      {
        id: 79,
        title: "TDSP PM Base Container",
        page_id: "290719333",
      },
    ],
  },
  {
    id: 28,
    title: "POD Industrialization",
    page_id: "422609195",
    children: [
      {
        id: 281,
        title: "About",
        page_id: "422609195",
      },
      {
        id: 282,
        title: "Deploy DAGs to MWAA (Airflow)",
        page_id: "423100722",
      },
      {
        id: 283,
        title: "Airflow DAG Deployment to Multi Environments in TDSP",
        page_id: "450955665",
      },
      {
        id: 284,
        title: "Airflow DAG Deployment to Multiple Airflow Clusters within the same Environment",
        page_id: "450956858",
      },
    ],
  },

  {
    id: 29,
    title: "TDSP - Orchestration",          
    page_id: "423100685",
    children: [
      {
        id: 291,
        title: "Orchestration",
        page_id: "370370228",
      },
      {
        id: 292,
        title: "Airflow Integrations",
        page_id: "387518810",
      },
      {
        id: 293,
        title: "DAG Status Cross-Account",
        page_id: "357706180",
      },
      {
        id: 294,
        title: "Design Philosophy",
        page_id: "290718655",
      },
      {
        id: 295,
        title: "Team Based Airflow Setup",
        page_id: "290718666",
      },
      {
        id: 296,
        title: "CI/CD & MLOps",
        page_id: "290719413",
      },
      {
        id: 297,
        title: "Integrations",
        page_id: "290719497",
      },
      {
        id: 298,
        title: "MWAA Learning",
        page_id: "290718638",
      },
      {
        id: 299,
        title: "Airflow Upgrades",         
        page_id: "445186248",
      },
      {
        id: 300,
        title: "Migrate Airflow Repo from XLR to GHA",
        page_id: "562954764",
      },
      {
        id: 3010,
        title: "Using Multiple GitHub repos for Airflow Orchestration",
        page_id: "563380556",
      }
    ],
  },
  {
    id: 8,
    title: "Monitoring and Alerting",
    page_id: "423035266",
    children: [
      {
        id: 81,
        title: "Application Monitoring",
        page_id: "371278757",
      },
      {
        id: 82,
        title: "Logging and Alerting",
        page_id: "371246646",
      },
      {
        id: 83,
        title: "DataDog Log Forwarding",
        page_id: "387518290",
      },
    ],
  },
  {
    id: 9,
    title: "Datadog",
    page_id: "406650998",
    children: [
      {
        id: 91,
        title: "Forwarding Databricks Job logs to Datadog",
        page_id: "406585581",
      },
      {
        id: 92,
        title: "Log Forwarding",
        page_id: "435848358",
      },
      {
        id: 93,
        title: "Dashboard ACL",
        page_id: "474775709",
      },
    ],
  },
  {
    id: 10,
    title: "MLOps Platform User Documentation",
    page_id: "563311063",
    children: [
      {
        id: 101,
        title: "MLOps Platform User Documentation",
        page_id: "563311063",
      },
      {
        id: 102,
        title: "Introduction on MLOps",
        page_id: "519898414",
      },
      // {
      //   id: 103,
      //   title: "MLOps Overview",
      //   page_id: "370268653",  // NotFound (404)
      // },
      {
        id: 104,
        title: "MLOps Persona",
        page_id: "523405611",
      },
  
      {
        id: 106,
        title: "Getting Started Prerequisite",
        page_id: "534087192",
      },
      {
        id: 107,
        title: "Setup",
        page_id: "578781736",
      },
      // {
      //   id: 108,
      //   title: "1. Introduction to Pipeline Components",
      //   page_id: "523437953",  // NotFound (404)
      // },
      {
        id: 109,
        title: "TDSP MLOps Template",
        page_id: "519832860",
      },
      {
        id: 110,
        title: "Initialize Pipelines - Setup Project Repo",
        page_id: "558728648",
      },
      {
        id: 111,
        title: "Repository Setup for Enabling GitHub Action and Runner",
        page_id: "500596994",
      },
      // {
      //   id: 112,
      //   title: "Best Practices",
      //   page_id: "519931886",  // Forbidden (403)
      // },
      // {
      //   id: 112,
      //   title: "1. Docker file Best Practices Guide",
      //   page_id: "483393984",  // Forbidden (403)
      // },
    ],
  },
  {
    id: 11,
    title: "AWS SageMaker - Pipelines",
    page_id: "423035266",
    children: [
      {
        id: 1101,
        title: "About",
        page_id: "578683598",
      },
      {
        id: 1102,
        title: "Pipelines",
        page_id: "454868905",
      },
      {
        id: 1103,
        title: "Training Pipeline",
        page_id: "519931385",
      },
      {
        id: 1104,
        title: "Training configurations",
        page_id: "592709420",
      },
      {
        id: 1105,
        title: "Inference Pipelines",
        page_id: "519898832",
      },
      {
        id: 1106,
        title: "Amazon SageMaker Batch Deployment",
        page_id: "468353679",
      },
      {
        id: 1107,
        title: "AWS SageMaker Batch Inference Configuration",
        page_id: "795511426",
      },
      {
        id: 1108,
        title: "Amazon SageMaker Endpoint Deployment",
        page_id: "523472712",
      },
      {
        id: 1109,
        title: "Endpoint Configurations",
        page_id: "561907300",
      },
    ],
  },
  {
    id: 12,
    title: "AWS SageMaker - Monitoring",
    page_id: "578683598",
    children: [
      {
        id: 1201,
        title: "Monitoring",
        page_id: "522846329",
      },
      {
        id: 1202,
        title: "Monitoring Types",
        page_id: "371312430",
      },
      {
        id: 1203,
        title: "Data Quality Monitoring",
        page_id: "559486260",
      },
      {
        id: 1204,
        title: "Model Quality Monitoring",
        page_id: "559585562",
      },
      {
        id: 1205,
        title: "Model Bias Monitoring",
        page_id: "559552609",
      },
      {
        id: 1206,
        title: "Monitoring Setup",
        page_id: "559552581",
      },
    ],
  },
  {
    id: 13,
    title: "AWS SageMaker - Feature Store",
    page_id: "578683598",
    children: [
      {
        id: 131,
        title: "Feature-Store",
        page_id: "519865626",
      },
      {
        id: 132,
        title: "Feature Group Batch Ingestion from Dbx",
        page_id: "518658858",
      },
      {
        id: 133,
        title: "Feature Group Creation",
        page_id: "520851830",
      },
      {
        id: 134,
        title: "Feature Group Consumption in Training Pipeline",
        page_id: "523376159",
      },
    ],
  },
  {
    id: 14,
    title: "Vertex AI",
    page_id: "513803865",
    children: [
      {
        id: 141,
        title: "About",
        page_id: "513803865",
      },
      {
        id: 142,
        title: "Batch Inference Pipeline: Vertex AI",
        page_id: "513771352",
      },
      {
        id: 143,
        title: "Live Inference Pipeline: Vertex AI",
        page_id: "513738902",
      },
      {
        id: 144,
        title: "Vertex AI Monitoring",
        page_id: "573376788",
      },
      {
        id: 145,
        title: "Vertex AI Alerting",
        page_id: "573344270",
      },
      {
        id: 146,
        title: "Vertex AI Doc's",
        page_id: "563400153",
      }
    ],
  },
  {
    id: 15,
    title: "DataDog Monitoring",
    page_id: "519898533",
    children: [
      {
        id: 151,
        title: "Datadog Log Forwarding Document",             
        page_id: "767689194",
      },
      {
        id: 152,
        title: "DataDog Log Forwarding Design",
        page_id: "454933824",
      },
      {
        id: 153,
        title: "Datadog dashboard template",
        page_id: "522290092",
      }
    ],
  },
  {
    id: 16,
    title: "Wandb Model Registry",
    page_id: "519898523",
    children: [
      {
        id: 1601,
        title: "About",
        page_id: "519898523",
      },
      {
        id: 1602,
        title: "Weights and Biases Pipeline Configurations",
        page_id: "522847068",
      },
      {
        id: 1603,
        title: "Wandb - Experimentation Tracking and Logging Artifacts",
        page_id: "522814160",
      }
    ],
  }
];


